import { useEffect, useState } from "react";
import { Bar, BarChart, CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { CalendarCheck, PhoneCall, Mail, Users, LifeBuoy, Eye } from "lucide-react";
import { Card, StatCard } from "../panel/PanelShell";
import { api } from "../../lib/api";

function ChartCard({ title, children }) {
  return <Card><h3 className="mb-4 text-sm font-bold text-navy">{title}</h3><div className="h-60">{children}</div></Card>;
}

export default function AdminOverview() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  if (!s) return <p className="text-sm text-slate-500">Loading analytics…</p>;
  return (
    <div className="space-y-6" data-testid="admin-overview">
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-6">
        <StatCard label="Consultations" value={s.consultations} icon={CalendarCheck} testid="admin-stat-consultations" />
        <StatCard label="Callbacks" value={s.callbacks} icon={PhoneCall} testid="admin-stat-callbacks" />
        <StatCard label="Enquiries" value={s.enquiries} icon={Mail} testid="admin-stat-enquiries" />
        <StatCard label="Clients" value={s.clients} icon={Users} testid="admin-stat-clients" />
        <StatCard label="Open tickets" value={s.open_tickets} icon={LifeBuoy} testid="admin-stat-tickets" />
        <StatCard label="Page views" value={s.page_views} icon={Eye} testid="admin-stat-views" />
      </div>
      <div className="grid gap-6 xl:grid-cols-2">
        <ChartCard title="Website page views (last 14 days)">
          <ResponsiveContainer><LineChart data={s.views_daily}><CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} /><XAxis dataKey="day" tick={{ fontSize: 11 }} /><YAxis allowDecimals={false} tick={{ fontSize: 11 }} width={30} /><Tooltip /><Line type="monotone" dataKey="count" stroke="#00C987" strokeWidth={2.5} dot={false} name="Views" /></LineChart></ResponsiveContainer>
        </ChartCard>
        <ChartCard title="Consultation bookings (last 14 days)">
          <ResponsiveContainer><BarChart data={s.leads_daily}><CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} /><XAxis dataKey="day" tick={{ fontSize: 11 }} /><YAxis allowDecimals={false} tick={{ fontSize: 11 }} width={30} /><Tooltip /><Bar dataKey="count" fill="#D6B36A" radius={[6, 6, 0, 0]} name="Bookings" /></BarChart></ResponsiveContainer>
        </ChartCard>
        <ChartCard title="Lead pipeline (all lead types)">
          <ResponsiveContainer><BarChart data={s.lead_status} layout="vertical"><XAxis type="number" allowDecimals={false} tick={{ fontSize: 11 }} /><YAxis type="category" dataKey="status" tick={{ fontSize: 11 }} width={80} /><Tooltip /><Bar dataKey="count" fill="#071426" radius={[0, 6, 6, 0]} name="Leads" /></BarChart></ResponsiveContainer>
        </ChartCard>
        <Card>
          <h3 className="mb-4 text-sm font-bold text-navy">Top pages</h3>
          <ul className="space-y-2 text-sm" data-testid="admin-top-pages">
            {s.top_pages.map((p) => <li key={p.path} className="flex justify-between border-b border-slate-100 pb-2"><span className="text-slate-600">{p.path}</span><span className="font-num font-semibold text-navy">{p.views}</span></li>)}
            {!s.top_pages.length && <li className="text-slate-500">No page views tracked yet.</li>}
          </ul>
        </Card>
      </div>
    </div>
  );
}
